// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"8292b2f3","1131":"8292b2f3","4113":"8292b2f3"}[chunkId] + ".chunk.css";
};